import { Stack } from '@mui/material';
import styled, { css } from 'styled-components';

export const CustomValue = styled(Stack)<{ $clickable?: boolean }>`
  && {
    flex-direction: row;
    gap: 0.375rem;
    align-items: center;

    ${({ $clickable }) =>
      $clickable &&
      css`
        cursor: pointer;
        .MuiTypography-root {
          transition: 0.3s ease-in-out;
        }
        &:hover {
          .MuiTypography-root {
            text-decoration: underline;
          }
        }
      `};
  }
`;
